import Vue from 'vue'
import Vuex from 'vuex'
import VueResource from 'vue-resource'
import invoices from './modules/invoices'
import downloads from './modules/downloads'
import users from './modules/users'
import clients from './modules/clients'
import notifications from './modules/notifications'
import profile from './modules/profile'
import campaigns from './modules/campaigns'
import modals from './modules/modals'
import creatives from './modules/creatives'
import assets from './modules/assets'
import links from './modules/links'
import tags from './modules/tags'
import auth from './modules/auth'
import encodingProfiles from './modules/encodingProfiles'
import monitor from './modules/monitor'
import render from './modules/render'
import plugins from './modules/plugins'
import fonts from './modules/fonts'
import ls from 'local-storage'
import router from '@/router/index.js'

Vue.use(Vuex)
Vue.use(VueResource)

Vue.http.options.root = process.env.VUE_APP_OTOMO_API_HOST
Vue.http.options.credentials = true // needed to send cookie in request

const store = new Vuex.Store({

  modules: {
    auth,
    invoices,
    users,
    clients,
    notifications,
    profile,
    campaigns,
    modals,
    creatives,
    assets,
    downloads,
    links,
    tags,
    encodingProfiles,
    plugins,
    fonts,
    monitor,
    render
  }
})

Vue.http.headers.common['X-Authorization'] = store.getters['auth/getAccessToken']

Vue.http.interceptors.push((request, next) => {
  next((response) => {
    if (response.status === 401 || response.status === 403) {
      store.dispatch('auth/logout').then(() => {
        ls.remove('ot-user')
        router.push('/login')
      })
    }
  })
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js